// «Буцаалт» жагсаалт ба шийдвэрлэх drawer-ын хуваалцсан тогтмол. Шат, хэнээс
// хүлээж буй, анхаарууштай эсэхийг сервер (de-order-service list) тооцоолж өгдөг;
// энд зөвхөн харуулах талын буулгалт.

export type ReturnStage = 0 | 1 | 2 | 3 | 4 | "DONE" | "CLOSED";
export type WaitingOn = "ME" | "THEM" | "NONE";
export type WaitingTab = "me" | "them" | "done" | "closed" | "all";

export const WAITING_TABS: WaitingTab[] = ["me", "them", "done", "closed", "all"];
export const STAGE_COUNT = 5;
export const STAGES: Exclude<ReturnStage, "DONE" | "CLOSED">[] = [0, 1, 2, 3, 4];

// «Шат» шүүлтүүр → тухайн шатанд хамаарах төлвүүд.
export const STAGE_STATUSES: Record<number, string[]> = {
  0: ["REQUESTED"],
  1: ["PROPOSED", "DISPUTED"],
  2: ["ACCEPTED", "AWAITING_PICKUP_SCHEDULE", "AWAITING_SHIPMENT_INFO", "IN_TRANSIT", "IN_TRANSIT_EXCEPTION"],
  3: ["AWAITING_WAREHOUSE_RECEIPT"],
  4: ["AWAITING_RESOLUTION", "REFUND_PENDING"],
};

export const OVERDUE_DAYS = 45;

export type NextAction =
  | "decide"
  | "repropose"
  | "schedulePickup"
  | "receive"
  | "recordTransfer"
  | "respond"
  | "open";

// Нийлүүлэгчийн «Надаас хүлээж буй» мөрийн үйлдэл. Худалдан авагчид зөвхөн
// PROPOSED дээр хариу өгөх (зөвшөөрөх / маргах) үйлдэл бий.
export function nextActionFor(status: string, isSeller: boolean): NextAction {
  if (!isSeller) return status === "PROPOSED" ? "respond" : "open";
  switch (status) {
    case "REQUESTED":
      return "decide";
    case "DISPUTED":
      return "repropose";
    case "AWAITING_PICKUP_SCHEDULE":
      return "schedulePickup";
    case "AWAITING_WAREHOUSE_RECEIPT":
      return "receive";
    case "REFUND_PENDING":
      return "recordTransfer";
    default:
      return "open";
  }
}

// Жагсаалтын төвлөрсөн (primary) товчтой үйлдлүүд.
export const PRIMARY_ACTIONS: NextAction[] = ["decide", "repropose"];

export type ResolutionKey = "money" | "deduct" | "swap" | "disc" | "simple" | "none";

export function resolutionKey(row: { resolutionType?: string | null; refundMethod?: string | null; requestType?: string | null }): ResolutionKey {
  switch (row.resolutionType) {
    case "REFUND_MONEY":
      return row.refundMethod === "INVOICE_DEDUCTION" ? "deduct" : "money";
    case "REPLACEMENT":
      return "swap";
    case "NEXT_ORDER_DISCOUNT":
      return "disc";
    case "NONE":
    case "MIXED":
      return "simple";
    default:
      return row.requestType === "SIMPLE" ? "simple" : "none";
  }
}

export type BarState = "done" | "now" | "warn" | "wait" | "todo";

// 5 зураас: өмнөх шатууд ногоон, одоогийнх (шаргал | улаан | индиго), дараагийнх хоосон.
export function stageBars(stage: ReturnStage, waitingOn: WaitingOn, alert: boolean): BarState[] {
  if (stage === "DONE") return Array(STAGE_COUNT).fill("done");
  if (stage === "CLOSED") return Array(STAGE_COUNT).fill("todo");
  const mode: BarState = alert ? "warn" : waitingOn === "THEM" ? "wait" : "now";
  return STAGES.map((s) => (s < stage ? "done" : s === stage ? mode : "todo"));
}

export const getStageKey = (stage: ReturnStage) => (stage === "DONE" ? "done" : stage === "CLOSED" ? "closed" : `s${stage}`);

// de-order-admin дахь буцаалтын дэлгэрэнгүй route. Агуулахын хүлээн авалт тусдаа
// хуудастай; бусад алхам (очиж авах товлох, шилжүүлэг бүртгэх) дэлгэрэнгүй дээр.
export function orderModuleReturnPath(id: string, status: string): string {
  return status === "AWAITING_WAREHOUSE_RECEIPT" ? `/returns/${id}/warehouse-receipt` : `/returns/${id}`;
}

// Drawer дотор бүрэн хэрэгжсэн ME алхмууд (шинэ form). Үлдсэн нь order модуль руу.
export function isDecisionStatus(status: string): boolean {
  return status === "REQUESTED" || status === "DISPUTED";
}
